import { getReduxStore } from '@/checkout-instore-legacy/redux/reduxStore'

import type { MetricAction, MetricShowcase } from './core/constants'
import { getSalesAssociateState } from './core/globalState'
import { getAccountName } from './core/utils/accountName'

export type MetricData = {
  value: unknown
  action: MetricAction
  showcase?: MetricShowcase
  currency?: string
  items_total?: number
  order_form_id?: string
  multiple_delivery?: boolean
  country?: string
  sales_channel?: string
  promotion_applied?: boolean
}

const EVENT_STREAM_APPLICATION_NAME = 'physical-stores-salesapp'

const EVENTS_API_URL = 'https://rc.vtex.com/api/analytics/schemaless-events'

export const sendMetric = (data: MetricData) => {
  const account = getAccountName()
  const reduxState = getReduxStore()?.getState()
  const salesAssociate = reduxState && getSalesAssociateState(reduxState)

  const bodyRequest = {
    name: EVENT_STREAM_APPLICATION_NAME,
    account,
    event: {
      web_app_version: typeof window !== 'undefined' ? window.APP_VERSION : '',
      vendor_email: salesAssociate?.user ?? '-',
      vendor_store_name: salesAssociate?.store_linked.name ?? '-',
      date: new Date().toISOString(),
      ...data,
    },
  }

  if (account === 'instoreqa' || process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('Physical Stores Sales App Metric skipped', bodyRequest)

    return
  }

  // eslint-disable-next-line no-restricted-syntax
  return fetch(EVENTS_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyRequest),
  })
}
